var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no-user@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-user",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#E5E5E5",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    id: "person_FILL1_wght400_GRAD0_opsz48",
    opacity: 0.151824951,
    transform: "translate(135.000000, 137.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116,108.695652 C100.05,108.695652 87,103.623188 76.85,93.4782609 C66.7,83.3333333 61.625,70.2898551 61.625,54.3478261 C61.625,38.4057971 66.7,25.3623188 76.85,15.2173913 C87,5.07246377 100.05,0 116,0 C131.95,0 145,5.07246377 155.15,15.2173913 C165.3,25.3623188 170.375,38.4057971 170.375,54.3478261 C170.375,70.2898551 165.3,83.3333333 155.15,93.4782609 C145,103.623188 131.95,108.695652 116,108.695652 L116,108.695652 Z M21.75,225 C15.7083333,225 10.5729167,222.886473 6.34375,218.65942 C2.11458333,214.432367 0,209.299517 0,203.26087 L0,190.942029 C0,181.763285 2.29583333,173.913043 6.8875,167.391304 C11.4791667,160.869565 17.4,155.917874 24.65,152.536232 C40.8416667,145.289855 56.36875,139.855072 71.23125,136.231884 C86.09375,132.608696 101.016667,130.797101 116,130.797101 C130.983333,130.797101 145.845833,132.669082 160.5875,136.413043 C175.329167,140.157005 190.795833,145.531401 206.9875,152.536232 C214.479167,155.917874 220.520833,160.869565 225.1125,167.391304 C229.704167,173.913043 232,181.763285 232,190.942029 L232,203.26087 C232,209.299517 229.885417,214.432367 225.65625,218.65942 C221.427083,222.886473 216.291667,225 210.25,225 L21.75,225 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/no-user.3281bfb94938c877f8922add94dbd5ed.svg";
export { ForwardRef as ReactComponent };